import React from "react";
import { Grid2 } from "@mui/material";
import { useTranslation } from "react-i18next";

import { acceleratorCardImages } from "../model/constants";

import { AcceleratorCard } from "./AcceleratorCard/AcceleratorCard";

type AcceleratorCardData = { title: string; description: string };

export const AcceleratorCards: React.FC = () => {
  const { t } = useTranslation();
  const acceleratorCardsMock = (
    t("projects.accelerators", { returnObjects: true }) as AcceleratorCardData[]
  ).map((card, index) => ({ ...card, image: acceleratorCardImages[index] }));

  return (
    <Grid2
      container
      columns={1}
      spacing={4}
      direction="row"
      alignItems="stretch"
    >
      {acceleratorCardsMock.map((projectCard) => (
        <AcceleratorCard
          key={projectCard.title}
          title={projectCard.title}
          description={projectCard.description}
          image={projectCard.image}
        />
      ))}
    </Grid2>
  );
};
